import { Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { Router } from '@angular/router';
import { UikImageAssetComponent } from '@visiativ/uik-am';
@Component({
	selector: 'app-page-not-found',
	templateUrl: './page-not-found.component.html',
	styleUrls: ['./page-not-found.component.scss'],
	standalone: true,
	imports: [MatButton, UikImageAssetComponent],
})
export class PageNotFoundComponent {
	private readonly router = inject(Router);
	backHome(): void {
		this.router.navigate(['/home']);
	}
}
